import { Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import {
  TerminalFinancing,
  type TerminalItemDto,
  TerminalInventoryStatus,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Merchants.OrbitLOnboarding.Detail;
const FINANCING_RESOURCES = Resources.Admin.Terminals.Financing;

type Props = {
  terminal: TerminalItemDto;
  onSwapClick: (terminal: TerminalItemDto) => void;
};

export const TerminalRow = ({ terminal, onSwapClick }: Props) => {
  const { t } = useResource();

  return (
    <Stack component="li" direction="row" alignItems="center" gap={1}>
      <Typography variant="body2" sx={{ minWidth: 220 }}>
        {terminal.serialNumber ?? "—"} ({terminal.hardwareModel ?? "—"})
      </Typography>
      {terminal.tid && (
        <Typography variant="body2" color="text.secondary">
          {t(RESOURCES.Tid)}: {terminal.tid}
        </Typography>
      )}
      {terminal.status === TerminalInventoryStatus.Deployed && (
        <Chip
          label={t(RESOURCES.TerminalStatusDeployed)}
          size="small"
          color="success"
          variant="outlined"
        />
      )}
      <Chip
        label={
          terminal.financing === TerminalFinancing.Hunter
            ? t(FINANCING_RESOURCES.Hunter)
            : t(FINANCING_RESOURCES.Moone)
        }
        size="small"
        variant="outlined"
      />
      {terminal.isSwappable && (
        <Tooltip title={t(RESOURCES.SwapTerminal)}>
          <IconButton
            size="small"
            onClick={() => onSwapClick(terminal)}
            sx={{
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
            }}
          >
            <SwapHorizIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};
